const { translations } = window;

const translateKey = key => {
  const translation = translations?.[key] || key;

  return translation.replace(/\\u(\w\w\w\w)/g, (a, b) => {
    const charcode = parseInt(b, 16);
    return String.fromCharCode(charcode);
  });
};

const translateMsg = (key, msg) => {
  const translation = translations?.[key] || msg;

  return translation.replace(/\\u(\w\w\w\w)/g, (a, b) => {
    const charcode = parseInt(b, 16);
    return String.fromCharCode(charcode);
  });
};

const translate = (key, msg) => {
  if (!key) {
    if (msg) return msg;
    return '';
  }
  if (msg) return translateMsg(key, msg);
  return translateKey(key);
};

export default translate;
